import { ReduxThunkAction } from 'src/global/store';

const Actions = {
  JOB_SEARCH: 'glints/GoogleTagManager/JOB_SEARCH',
};

type searchInputTrackingInput = {
  searchKeywords: string;
  searchLocation: string;
};

export function trackSearchInput({
  searchKeywords,
  searchLocation,
}: searchInputTrackingInput): ReduxThunkAction<any> {
  return (dispatch) => {
    return dispatch({
      type: Actions.JOB_SEARCH,
      payload: {
        searchLocation,
        searchKeywords: searchKeywords?.trim().toLocaleLowerCase(),
      },
    });
  };
}
